import { Header } from './header';
import { ItemContext, ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { OccurrenceDescription } from './occurrence-description';
import { CausesAnalysis } from './causes-analysis';
import { ActionPlan } from './action-plan';
import type { EventReportData } from './types';

export function GoiasaAccidentAnalysis(props: { reportData: EventReportData }) {
  return (
    <ReportContext value={props.reportData}>
      <div style={{ breakAfter: 'page', color: '#000', backgroundColor: '#fff', fontSize: '13px' }}>
        {props.reportData.body.items.map((item, index) => (
          <ItemContext key={index} value={item}>
            <div
              style={{
                width: '100vw',
                backgroundColor: 'white',
                fontFamily: 'sans-serif',
              }}
            >
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '54rem',
                }}
              >
                <div
                  style={{
                    backgroundColor: '#fff',
                  }}
                >
                  <Header />
                  <InitialInfos />
                  <OccurrenceDescription />
                  <CausesAnalysis />
                  <ActionPlan />
                </div>
              </div>
            </div>
          </ItemContext>
        ))}
      </div>
    </ReportContext>
  );
}
